import { colors } from '@material-ui/core';
import { createTheme, responsiveFontSizes } from '@material-ui/core/styles';
import typography from './typography';

let theme = createTheme({
    palette: {
        background: {
            default: '#f4f6f8',
            paper: colors.common.white,
        },
        primary: {
            main: '#000',
        },
        secondary: {
            main: '#fff',
        },
        text: {
            primary: colors.blueGrey[900],
            secondary: colors.blueGrey[600],
        },
    },
    typography: typography,
});

theme = responsiveFontSizes(theme);

export default theme;
